import { useState, useEffect } from "react";
import Navbar         from "../components/Navbar";
import NavbarStaff    from "../components/NavbarStaff";
import { NavbarAdmin } from "../components/NavbarAdmin";
import API from "../config";

/**
 * useNavbar
 * อ่าน role จาก localStorage token → คืน Navbar component ที่ถูกต้อง
 * - admin  → NavbarAdmin
 * - staff  → NavbarStaff
 * - อื่น   → Navbar (public)
 */
export function useNavbar() {
  const [NavbarComponent, setNavbarComponent] = useState(() => Navbar);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    fetch(`${API}/api/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.role === "admin")       setNavbarComponent(() => NavbarAdmin);
        else if (data.role === "staff")  setNavbarComponent(() => NavbarStaff);
        else                             setNavbarComponent(() => Navbar);
      })
      .catch(() => {});
  }, []);

  return NavbarComponent;
}